import { Configuration, FrontendApi, ResponseError, type Session } from "@ory/client-fetch";

export type FlowKind = "login" | "registration" | "recovery" | "verification" | "settings";

export class Kratos {
  readonly api: FrontendApi;
  constructor(readonly baseUrl: string) {
    this.api = new FrontendApi(new Configuration({ basePath: baseUrl, credentials: "include" }));
  }

  /** Full-page redirect that creates a browser flow; Kratos redirects back with ?flow=. */
  browserFlowUrl(kind: FlowKind, params: Record<string, string | undefined> = {}): string {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) if (v) qs.set(k, v);
    const q = qs.toString();
    return `${this.baseUrl}/self-service/${kind}/browser${q ? `?${q}` : ""}`;
  }

  async getFlow(kind: FlowKind, id: string) {
    switch (kind) {
      case "login":
        return this.api.getLoginFlow({ id });
      case "registration":
        return this.api.getRegistrationFlow({ id });
      case "recovery":
        return this.api.getRecoveryFlow({ id });
      case "verification":
        return this.api.getVerificationFlow({ id });
      case "settings":
        return this.api.getSettingsFlow({ id });
    }
  }

  async session(): Promise<Session | null> {
    try {
      return await this.api.toSession();
    } catch (e) {
      if (e instanceof ResponseError && (e.response.status === 401 || e.response.status === 403)) return null;
      throw e;
    }
  }

  async logout(returnTo?: string) {
    const { logout_url } = await this.api.createBrowserLogoutFlow({ returnTo });
    window.location.href = logout_url;
  }
}

export { ResponseError };
